export default {
  container: {
    display: 'flex',
  },
};
